var _linearGradient, _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoBillIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "placeholder no bill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 362,
    height: 175,
    viewBox: "0 0 362 175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b33u0qnwjb",
    x1: 0.5,
    y1: 0.07,
    x2: 0.5,
    y2: 0.919,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4e9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f8f8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "h1ycg78lia"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(502 267)",
    style: {
      fill: "red"
    },
    d: "M0 0h362v175H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-502 -267)",
    style: {
      clipPath: "url(#h1ycg78lia)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152 0h58a152 152 0 0 1 152 152H0A152 152 0 0 1 152 0z",
    transform: "translate(502 290)",
    style: {
      fill: "url(#b33u0qnwjb)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 221",
    d: "M10 0h45l26.668 26.667V110a10 10 0 0 1-10 10H10a10 10 0 0 1-10-10V10A10 10 0 0 1 10 0z",
    transform: "translate(636 267)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 224",
    d: "M10.036 120A10.019 10.019 0 0 1 0 110V10A10.017 10.017 0 0 1 10.036 0H56.9L82 25v85a10.019 10.019 0 0 1-10.039 10zM5.016 10v100a5.018 5.018 0 0 0 5.02 5h61.925a5.014 5.014 0 0 0 5.016-5V30.834h-25.1V5H10.036a5.018 5.018 0 0 0-5.02 5zM56.9 25.836h19.25L56.9 6.667z",
    transform: "translate(636.186 267)",
    style: {
      fill: "#a4b0b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 223",
    d: "M31.3 58.852a3.462 3.462 0 1 1 0-6.924h15.692a3.462 3.462 0 1 1 0 6.924zM3.461 41.542a3.462 3.462 0 1 1 0-6.924h43.532a3.462 3.462 0 1 1 0 6.924zm0-17.309a3.462 3.462 0 1 1 0-6.924h43.532a3.462 3.462 0 1 1 0 6.924zm0-17.309a3.462 3.462 0 1 1 0-6.924h43.532a3.462 3.462 0 1 1 0 6.924z",
    transform: "rotate(180 350.881 173.264)",
    style: {
      fill: "#a4b0b5"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 222",
    d: "M-233.789-183.986h-2.373l.883-1.819h1.227a5.392 5.392 0 0 1-.026-.644 5.873 5.873 0 0 1 .026-.674h-1.957l.888-1.814h1.356a8.574 8.574 0 0 1 8.649-6.586 9.47 9.47 0 0 1 5.757 1.814l-1.695 3.321a6.138 6.138 0 0 0-4.114-1.507 4.93 4.93 0 0 0-4.8 2.958h8.079l-.966 1.814h-7.545a5.654 5.654 0 0 0-.026.674 5.183 5.183 0 0 0 .026.644h6.825l-.935 1.819h-5.449a4.917 4.917 0 0 0 4.8 2.979 6.054 6.054 0 0 0 4.114-1.528l1.695 3.341a9.469 9.469 0 0 1-5.757 1.814 8.615 8.615 0 0 1-8.682-6.606z",
    transform: "translate(921.119 548.688)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(41 947.934 279.82)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 278",
    transform: "translate(850.03 502.083)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M0 0h12.502v10.587H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 66",
    d: "M39.648 0A39.648 39.648 0 1 1 0 39.648 39.648 39.648 0 0 1 39.648 0z",
    transform: "translate(773.246 467.263)",
    style: {
      fill: "#d4e9f5",
      opacity: 0.663
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 279",
    transform: "translate(850.03 502.083)",
    style: {
      fill: "#b1b1b1"
    },
    d: "M0 0h7.501v10.587H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 66",
    d: "M41.155 9.543a31.612 31.612 0 1 0 31.612 31.612A31.648 31.648 0 0 0 41.155 9.543m0-9.543A41.155 41.155 0 1 1 0 41.155 41.155 41.155 0 0 1 41.155 0z",
    transform: "translate(772 466.016)",
    style: {
      fill: "#c7c7c7"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 225",
    d: "M0 0h57.008a8 8 0 0 1 8 8v.637a8 8 0 0 1-8 8H0z",
    transform: "translate(862.532 499.058)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 66",
    cx: 5.001,
    cy: 7.501,
    rx: 5.001,
    ry: 7.501,
    transform: "rotate(-9 3599.27 -4718.922)",
    style: {
      opacity: 0.837,
      fill: "#fff"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 280",
    width: 68,
    height: 2,
    rx: 1,
    transform: "translate(643 440)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBillIcon);
export default __webpack_public_path__ + "static/media/no-bill-icon.d773380fb5e10a6962cc1b40d0eb93ef.svg";
export { ForwardRef as ReactComponent };